import {
  chainCommands,
  createParagraphNear,
  liftEmptyBlock,
  newlineInCode,
  splitBlockAs,
} from "prosemirror-commands";
import { type Command } from "prosemirror-state";

const listItemTypes = ["bullet_list_item", "ordered_list_item"];

const splitBlockWithListItemHandling = splitBlockAs((node, atEnd) => {
  // If we're in a list item that has text, and the cursor is at the end of it,
  // create a new list item (instead of a new paragraph).
  if (listItemTypes.includes(node.type.name) && node.content.size && atEnd) {
    return { type: node.type };
  }
  return null;
});

export const enterCommand = chainCommands(
  newlineInCode,
  createParagraphNear,
  liftEmptyBlock,
  splitBlockWithListItemHandling,
);

const replaceDashOrAsteriskWithBulletList: Command = (state, dispatch) => {
  const { $from, from, $to, to, empty } = state.selection;
  if (!empty || $from.parent.type.name !== "paragraph") {
    return false;
  }
  const textBefore = $from.parent.textBetween(0, $to.parentOffset);
  if (!["-", "*"].includes(textBefore)) {
    return false;
  }
  if (dispatch) {
    const tr = state.tr;
    tr.setBlockType(from, to, state.schema.nodes.bullet_list_item);
    // delete the dash/asterisk
    tr.delete(from - 1, from);
    dispatch(tr.scrollIntoView());
  }
  return true;
};

const replaceOneWithOrderedList: Command = (state, dispatch) => {
  const { $from, from, $to, to, empty } = state.selection;
  if (!empty || $from.parent.type.name !== "paragraph") {
    return false;
  }
  const textBefore = $from.parent.textBetween(0, $to.parentOffset);
  if (textBefore !== "1.") {
    return false;
  }
  if (dispatch) {
    const tr = state.tr;
    tr.setBlockType(from, to, state.schema.nodes.ordered_list_item);
    // delete the "1."
    tr.delete(from - 2, from);
    dispatch(tr.scrollIntoView());
  }
  return true;
};

export const spaceCommand = chainCommands(
  replaceDashOrAsteriskWithBulletList,
  replaceOneWithOrderedList,
);
